import { UserReportDTO } from "../DTO/userReportDTO";
import { Address } from "./address";

export class UserReport{
    public id!: number;
    public roleName!: string;
    public firstName!: string;
    public lastName!: string;
    public email!: string;
    public phoneNumber!: string;
    public entityType!: string;
    public entityName!: string;
    public entityCreated?: Date
    public entityAddress!: Address;
    public lockoutEnabled!: boolean;
    public twoFactorEnabled!: boolean;
    public deleted!: boolean;
    public premierIntegrations!: string[];

    get isAdmin():boolean{
        return this.roleName?.toLowerCase().includes('admin');
    }

    get premierIntegrationsDisplay():string{
        return this.premierIntegrations?.length>0?this.premierIntegrations.join(', '):'';
    }

    get status():string{
        return this.deleted?'Inactive':(this.lockoutEnabled?'Locked Out':'Active');
    }

    public static mapFromDTO(param:UserReportDTO):UserReport{ 
        if (!param || !param.id) throw new Error("parameter is null")
        let obj = new UserReport();
        try
        {
            obj.id = param.id;
            obj.roleName = param.roleName;
            obj.firstName = param.firstName;
            obj.lastName = param.lastName;
            obj.email = param.email;
            obj.phoneNumber = param.phoneNumber;
            obj.entityType = param.entityType;
            obj.entityName = param.entityName;
            if(param.entityCreated) obj.entityCreated = new Date(param.entityCreated);
            if(param.entityAddressList && param.entityAddressList.length>0) obj.entityAddress = Address.mapFromDTO(param.entityAddressList[0]);
            obj.lockoutEnabled = param.lockoutEnabled;
            obj.twoFactorEnabled = param.twoFactorEnabled;
            obj.deleted = param.deleted;
            obj.premierIntegrations = param.premierIntegrations;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:UserReport):UserReportDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new UserReportDTO();
        try
        {
            dto.id = param.id;
            dto.roleName = param.roleName;
            dto.firstName = param.firstName;
            dto.lastName = param.lastName;
            dto.email = param.email;
            dto.phoneNumber = param.phoneNumber;
            dto.entityType = param.entityType;
            dto.entityName = param.entityName;
            if(param.entityCreated) dto.entityCreated = param.entityCreated.toISOString();
            if(param.entityAddress) dto.entityAddressList = [Address.mapToDTO(param.entityAddress)];
            dto.lockoutEnabled = param.lockoutEnabled;
            dto.twoFactorEnabled = param.twoFactorEnabled;
            dto.deleted = param.deleted;
            dto.premierIntegrations = param.premierIntegrations;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}